import React from 'react';
import Modal from 'components/common/Modal';
import VisualizadorPDF from '../contasReceber/components/VisualizadorPDF';

const ModalPreviewRelatorioPdf = ({ isOpen, onClose, dataUrl, fileName }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Pré-visualização do Relatório" size="full">
      <div>
        {dataUrl ? (
          <VisualizadorPDF dataURL={dataUrl} nomeArquivo={fileName || 'relatorio.pdf'} />
        ) : (
          <div className="text-sm text-[color:var(--text-muted)]">PDF indisponível para pré-visualização.</div>
        )}
      </div>
    </Modal>
  );
};

export default ModalPreviewRelatorioPdf;
